const getGroupedAmount = (amount, currencyCode) => {
  if (amount === null || amount === undefined || amount === "") {
    return "0.00";
  }

  const numericAmount = Number(amount);

  if (Number.isNaN(numericAmount)) {
    return "0.00";
  }

  const locale = currencyCode === "INR" ? "en-IN" : "en-US";

  return numericAmount.toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const resolveCurrencyCode = (currency) =>
  currency?.name || currency?.code || null;

export const resolveOrderCurrencyCode = (currency, currencyList = []) => {
  if (currency?.name || currency?.code) {
    return currency.name || currency.code;
  }

  if (currency?.id != null) {
    const matchedCurrency = currencyList.find(
      (item) => Number(item.id) === Number(currency.id),
    );

    if (matchedCurrency) {
      return matchedCurrency.code || matchedCurrency.name || null;
    }
  }

  return null;
};

export const resolveCurrencyCodeById = (currencyId, currencyList = []) =>
  resolveOrderCurrencyCode(
    currencyId == null ? null : { id: currencyId },
    currencyList,
  );

export const resolveCurrencyCodeByCountryId = (
  countryId,
  currencyByCountryMap = {},
  currencyList = [],
) => {
  if (countryId == null) {
    return null;
  }

  const currencyId =
    currencyByCountryMap[countryId] ??
    currencyByCountryMap[Number(countryId)] ??
    currencyByCountryMap[String(countryId)];

  return resolveCurrencyCodeById(currencyId, currencyList);
};

export const formatMonetaryAmount = (amount, currencyCode) => {
  const groupedAmount = getGroupedAmount(amount, currencyCode);
  if (!currencyCode) {
    return groupedAmount;
  }
  return `${currencyCode} ${groupedAmount}`;
};

export const formatOrderMonetaryAmount = (amount, currency) =>
  formatMonetaryAmount(amount, resolveCurrencyCode(currency));

export const formatOrderAmount = (amount, order, currencyList = []) =>
  formatMonetaryAmount(
    amount,
    resolveOrderCurrencyCode(order?.currency, currencyList),
  );

export const formatRefundAmount = (refundDetail, orderCurrencyCode) => {
  if (refundDetail?.inr_conversion != null) {
    return formatMonetaryAmount(refundDetail.inr_conversion, "INR");
  }

  return formatMonetaryAmount(
    refundDetail?.refunded_amount,
    orderCurrencyCode,
  );
};
